import { FC } from 'react';
import { IconProps } from '../../types';

export const Silver: FC<IconProps> = ({ width = 15, height = 15, ...props }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M0 7.5C0 3.35786 3.35786 0 7.5 0C11.6421 0 15 3.35786 15 7.5C15 11.6421 11.6421 15 7.5 15C3.35786 15 0 11.6421 0 7.5Z"
        fill="url(#paint0_linear_6141_58473)"
      />
      <path
        d="M9.35191 3.888V5.016C9.03991 4.824 8.73991 4.644 8.36791 4.644C8.21191 4.644 8.09191 4.68 8.03191 4.704C7.58791 4.86 7.37191 5.304 7.37191 5.748C7.38391 6.156 7.55191 6.468 7.80391 6.768C8.10391 7.14 8.43991 7.476 8.76391 7.812C9.35191 8.436 9.69991 8.868 9.69991 9.756C9.69991 9.948 9.68791 10.644 9.33991 11.208C9.18391 11.448 8.99191 11.64 8.76391 11.784C8.33191 12.06 7.92391 12.072 7.74391 12.072C7.09591 12.072 6.66391 11.844 6.43591 11.736V10.572C6.54391 10.632 7.02391 10.956 7.55191 10.956C7.81591 10.956 8.00791 10.872 8.09191 10.812C8.24791 10.704 8.53591 10.38 8.53591 9.852C8.53591 9.144 8.12791 8.844 7.28791 7.956C6.67591 7.296 6.19591 6.768 6.19591 5.808C6.19591 5.592 6.21991 5.004 6.54391 4.476C6.73591 4.176 7.21591 3.54 8.18791 3.54C8.77591 3.54 9.15991 3.78 9.35191 3.888Z"
        fill="#F8F8F8"
      />
      <defs>
        <linearGradient
          id="paint0_linear_6141_58473"
          x1="7"
          y1="18"
          x2="7"
          y2="-3.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#868686" />
          <stop offset="0.239" stopColor="#646464" />
          <stop offset="0.464" stopColor="#C6C6C6" />
          <stop offset="1" stopColor="#7E7E7E" />
        </linearGradient>
      </defs>
    </svg>
  );
};
